export { ContentKind } from "GenAlphaModel";
